import * as z from "zod";

const PickLineForWorkOrderSchema_ = z.object({
  pickLineId: z.string(),
  workOrderId: z.string(),
  productId: z.string().nullable(),
  productName: z.string().nullable(),
  productSku: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  quantityRequired: z.number(),
  quantityPicked: z.number(),
  status: z.string(),
});
export const PickLineForWorkOrderSchema: z.ZodType<PickLineForWorkOrder> =
  PickLineForWorkOrderSchema_;
export interface PickLineForWorkOrder extends z.infer<
  typeof PickLineForWorkOrderSchema_
> {}

export const getPickLinesForWorkOrders = {
  name: "getPickLinesForWorkOrders" as const,
  input: z.object({ workOrderIds: z.array(z.string()).min(1).max(500) }),
  output: z.object({ lines: z.array(PickLineForWorkOrderSchema) }),
};
